import { cn } from "@/lib/utils";

interface EligibilityCriteriaData {
  id?: number;
  page_id?: number;
  component_id?: number;
  title: string;
  title_text_color?: string;
  description: string;
  description_text_color?: string;
  background_color?: string;
  variant?: string;
}

interface EligibilityCriteriaProps {
  data: EligibilityCriteriaData;
}

function EligibilityCriteria({ data }: any) {
  const {
    title = "Eligibility Criteria",
    title_text_color = "#FFFFFF",
    description = "",
    description_text_color = "#FFFFFF",
    background_color = "#7f64e3",
  } = data.data || {};
  return (
    <div
      className={cn(
        "px-5 py-8 sm:px-8 sm:py-6",
        "flex justify-center items-center flex-col w-full",
        "gap-spacing-14 sm:gap-spacing-20 md:gap-spacing-24"
      )}
      style={{ backgroundColor: background_color }}
    >
      <p
        className={cn(
          "text-center",
          "text-heading-6-semibold",
          "sm:text-heading-5-semibold",
          "md:text-heading-4-semibold",
          "lg:text-new-heading-34-semibold",
          "xl:text-new-heading-42-semibold",
          "line-clamp-1"
        )}
        style={{ color: title_text_color }}
      >
        {title}
      </p>
      <p
        className={cn(
          "text-center",
          "text-body-2-regular",
          "sm:text-body-3-regular",
          "md:text-body-2-regular",
          "lg:text-body-1-regular",
          "xl:text-heading-6-regular",
          "line-clamp-3 sm:line-clamp-1"
        )}
        style={{ color: description_text_color }}
      >
        {description}
      </p>
      <span
        className="text-body-3-regular underline cursor-pointer"
        style={{ color: description_text_color }}
      >
        Read more
      </span>
    </div>
  );
}

export default EligibilityCriteria;
